import React, { useState } from 'react';
import { 
  Check, 
  X, 
  ChevronDown, 
  ShieldCheck, 
  Star, 
  MessageCircle, 
  Users, 
  Award, 
  BookOpen, 
  Heart, 
  Sparkles, 
  CheckCircle2, 
  HelpCircle,
  ArrowRight,
  Gift,
  Lock,
  Instagram,
  GraduationCap,
  Cog,
  Newspaper,
  FileText
} from 'lucide-react';
import { getCheckoutUrlWithUtms } from '@/lib/checkout';

const CHECKOUT_BASIC = "https://pay.hotmart.com/B99235195O?off=ihd0ljwt&checkoutMode=10";
const WHATSAPP_LINK = "https://wa.me/5551983007447?text=Ol%C3%A1%2C%20acessei%20o%20site%20e%20tenho%20uma%20d%C3%BAvida%20sobre%20o%20curso%20Amamenta%C3%A7%C3%A3o%20na%20Pr%C3%A1tica.";
const PRIVACY_LINK = "https://curso.metodopps.com.br/termos-e-politicas#privacidade";

const scrollToOffer = () => {
  const offerSection = document.getElementById('oferta');
  if (offerSection) {
    offerSection.scrollIntoView({ behavior: 'smooth' });
  } else {
    window.location.href = CHECKOUT_BASIC;
  }
};

interface AmamentacaoPraticaLPProps {
  checkoutUrl?: string;
  priceFrom?: string;
  priceMain?: string;
  priceInstallments?: string;
  vsl?: React.ReactNode;
}

export const AmamentacaoPraticaLP: React.FC<AmamentacaoPraticaLPProps> = ({
  checkoutUrl = CHECKOUT_BASIC,
  priceFrom = "De R$497,00",
  priceMain = "R$ 97,00",
  priceInstallments = "ou em até 12x de R$ 10,03 sem juros",
  vsl,
}) => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen font-sans bg-white text-gray-900 selection:bg-[#c46bbb]/20 selection:text-[#5f448f]">
      
      {/* SEÇÃO 01 — Banner de topo */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-[#5f448f] via-[#a54d9e] to-[#c46bbb] text-white py-2.5 px-4 shadow-md">
        <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 text-center">
          <Sparkles className="w-4 h-4 text-[#facc15] animate-pulse flex-shrink-0" />
          <span className="text-xs sm:text-sm font-semibold tracking-wide uppercase text-purple-100">
            Método PPS — Amamentação na Prática
          </span>
        </div>
      </div>

      {/* SEÇÃO 02 — Hero */}
      <section className="relative pt-8 pb-16 md:pt-12 md:pb-24 bg-gradient-to-b from-[#fff5f7] via-[#faf5ff] to-white overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
          
          {vsl ? (
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#5f448f]/10 border border-[#5f448f]/20 text-[#5f448f] font-semibold text-xs md:text-sm mb-6">
                <span className="w-2 h-2 rounded-full bg-[#5f448f] animate-ping" />
                <span>Método PPS — Posição, Pega e Sucção</span>
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-extrabold text-[#111827] leading-tight mb-8">
                O que faz uma mamada ser confortável e prazerosa, enquanto outra dói do começo ao fim?
              </h1>

              <div className="mb-8">
                {vsl}
              </div>

              <div className="my-6 p-4 sm:p-5 rounded-2xl bg-[#faf5ff] border-l-4 border-[#5f448f] shadow-sm text-left">
                <p className="text-[#374151] font-extrabold text-base sm:text-lg md:text-xl leading-relaxed">
                  <span className="text-[#a54d9e]">✨ Não é sorte.</span> Comece com essas 3 letras: <mark className="bg-[#facc15] text-[#111827] px-2 py-0.5 rounded-lg font-black inline-block shadow-sm">P P S.</mark>
                </p>
              </div>

              <p className="text-base sm:text-lg md:text-xl text-[#374151] font-medium leading-relaxed mt-4">
                Descubra como ativar os 3 pilares da amamentação sem dor e com muito leite, e aplique já na próxima mamada.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
              
              {/* Coluna de Texto (Esquerda) */}
              <div className="lg:col-span-7 text-center lg:text-left">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#5f448f]/10 border border-[#5f448f]/20 text-[#5f448f] font-semibold text-xs md:text-sm mb-6">
                  <span className="w-2 h-2 rounded-full bg-[#5f448f] animate-ping" />
                  <span>Método PPS — Posição, Pega e Sucção</span>
                </div>

                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-extrabold text-[#111827] leading-tight mb-6">
                  O que faz uma mamada ser confortável e prazerosa, enquanto outra dói do começo ao fim?
                </h1>

                <div className="my-6 p-4 sm:p-5 rounded-2xl bg-[#faf5ff] border-l-4 border-[#5f448f] shadow-sm text-left">
                  <p className="text-[#374151] font-extrabold text-base sm:text-lg md:text-xl leading-relaxed">
                    <span className="text-[#a54d9e]">✨ Não é sorte.</span> Comece com essas 3 letras: <mark className="bg-[#facc15] text-[#111827] px-2 py-0.5 rounded-lg font-black inline-block shadow-sm">P P S.</mark>
                  </p>
                </div>

                <p className="text-base sm:text-lg md:text-xl text-[#374151] font-medium leading-relaxed mt-4 mb-8">
                  Descubra como ativar os 3 pilares da amamentação sem dor e com muito leite, e aplique já na próxima mamada.
                </p>


              </div>

              {/* Coluna da Imagem (Direita) */}
              <div className="lg:col-span-5 flex justify-center">
                <div className="relative max-w-md w-full">
                  {/* Glow de fundo */}
                  <div className="absolute -inset-2 bg-gradient-to-tr from-[#5f448f] via-[#c46bbb] to-[#3cacae] rounded-[32px] blur-lg opacity-30 animate-pulse" />
                  
                  <div className="relative bg-white p-3 rounded-[28px] shadow-2xl border border-purple-100">
                    <img
                      src="/lovable-uploads/mae_amamentando_bebe.png"
                      alt="Mãe feliz amamentando seu bebê com conforto"
                      className="rounded-[22px] w-full h-auto object-cover shadow-inner"
                      loading="eager"
                    />
                    
                    {/* Badge Flutuante */}
                    <div className="absolute -bottom-4 -left-4 bg-white/95 backdrop-blur-md p-3 sm:p-4 rounded-2xl shadow-xl border border-purple-100 flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-[#5f448f] text-white flex items-center justify-center font-bold">
                        <Heart className="w-5 h-5 fill-current text-[#facc15]" />
                      </div>
                      <div>
                        <div className="font-extrabold text-xs sm:text-sm text-gray-900">+15.000 Duplas</div>
                        <div className="text-[10px] sm:text-xs text-gray-500 font-medium">Amamentando sem dor</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          )}

        </div>
      </section>

      {/* SEÇÃO 03 — Caixa de destaque + gancho */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          

          {/* Corpo do gancho */}
          <div className="space-y-6 text-gray-800 text-base sm:text-lg md:text-xl leading-relaxed">
            <p className="font-semibold text-gray-900 text-xl sm:text-2xl">
              Por que algumas mães parecem "nascer sabendo" amamentar e outras se sentem perdidas desde a primeira mamada?
            </p>

            <p className="text-[#a54d9e] font-bold text-lg sm:text-xl">
              A resposta não tem nada a ver com sorte ou privilégio.
            </p>

            <p>
              Se você está grávida e tem medo de não saber o que fazer quando o bebê nascer — ou se já é mãe e está sofrendo com dor a cada mamada — <mark className="bg-[#facc15] text-[#111827] font-extrabold px-1.5 py-0.5 rounded">o problema pode estar na técnica da amamentação, não em você!</mark>
            </p>

            <div className="p-6 bg-[#fff5f7] rounded-2xl border-l-4 border-[#c46bbb] my-6">
              <p className="font-medium text-gray-900">
                Amamentar é uma habilidade que se aprende — sua e do seu bebê, juntas. E, como toda habilidade, ela tem uma técnica certa por trás.
              </p>
            </div>

            <p className="font-extrabold text-[#5f448f] text-xl sm:text-2xl text-center py-2">
              E tudo que você precisa é dessa técnica certa.
            </p>
          </div>

        </div>
      </section>

      {/* SEÇÃO 04 — Autoridade da ciência */}
      <section className="py-16 bg-[#faf5ff] border-y border-purple-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center space-y-6">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#3cacae]/10 text-[#3cacae] font-bold text-xs sm:text-sm uppercase tracking-wider">
            <Award className="w-4 h-4" />
            <span>Embasamento Científico</span>
          </div>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-800 font-medium leading-relaxed max-w-3xl mx-auto">
            A ciência já mostrou, muitas vezes, que a diferença entre uma amamentação tranquila e uma amamentação dolorosa não está na genética da mãe nem na "sorte" do bebê — <mark className="bg-[#facc15] text-[#111827] font-extrabold px-1.5 py-0.5 rounded">está em três coisas específicas, observáveis, que dá pra aprender antes mesmo de precisar delas.</mark>
          </p>

          <p className="text-xl sm:text-2xl font-extrabold text-[#5f448f]">
            Você só precisa saber exatamente o que observar.
          </p>
        </div>
      </section>

      {/* SEÇÃO 05 — Barra de autoridade (5 números em grade horizontal) */}
      <section className="py-12 bg-gradient-to-r from-[#5f448f] via-[#4a3371] to-[#5f448f] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 text-center">
            
            <div className="p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 flex flex-col justify-center items-center">
              <span className="text-3xl sm:text-4xl font-extrabold text-[#facc15] mb-2">+15.000</span>
              <span className="text-xs sm:text-sm font-medium text-purple-100 leading-snug">
                duplas mãe-bebê transformadas
              </span>
            </div>

            <div className="p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 flex flex-col justify-center items-center">
              <span className="text-3xl sm:text-4xl font-extrabold text-[#facc15] mb-2">25 Anos</span>
              <span className="text-xs sm:text-sm font-medium text-purple-100 leading-snug">
                de atuação como mestre em nutrição materno-infantil e consultora internacional em amamentação
              </span>
            </div>

            <div className="p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 flex flex-col justify-center items-center">
              <span className="text-2xl sm:text-3xl font-extrabold text-[#facc15] mb-2">IBCLC</span>
              <span className="text-xs sm:text-sm font-medium text-purple-100 leading-snug">
                certificação internacional em consultoria de lactação
              </span>
            </div>

            <div className="p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 flex flex-col justify-center items-center">
              <span className="text-3xl sm:text-4xl font-extrabold text-[#facc15] mb-2">+2.000</span>
              <span className="text-xs sm:text-sm font-medium text-purple-100 leading-snug">
                profissionais de saúde formados com o Método
              </span>
            </div>

            <div className="p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 flex flex-col justify-center items-center sm:col-span-2 lg:col-span-1">
              <span className="text-3xl sm:text-4xl font-extrabold text-[#facc15] mb-2">+70 Mil</span>
              <span className="text-xs sm:text-sm font-medium text-purple-100 leading-snug">
                seguidores no Instagram
              </span>
            </div>

          </div>
        </div>
      </section>

      {/* SEÇÃO 06 — Contexto/problema macro */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-8 text-gray-800 text-base sm:text-lg md:text-xl leading-relaxed">
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 text-center leading-tight">
            A realidade do aleitamento materno no Brasil
          </h2>

          <p>
            As dificuldades que envolvem dor na amamentação, baixa produção de leite, baixo ganho de peso do bebê e desmame precoce não são um problema raro, nem um sinal de que algo está errado com você.
          </p>

          <div className="p-6 sm:p-8 bg-[#fff5f7] rounded-3xl border border-pink-100 space-y-4">
            <p className="font-medium text-gray-900 leading-relaxed">
              É, na verdade, um dos motivos mais comuns de desmame precoce no Brasil: segundo o ENANI-2019 (Ministério da Saúde, em parceria com a UFRJ e a Fiocruz — a pesquisa nacional oficial sobre aleitamento), <mark className="bg-[#facc15] text-[#111827] font-extrabold px-1.5 py-0.5 rounded">apenas 45,8% dos bebês brasileiros chegam aos 6 meses em amamentação exclusiva como recomenda a OMS</mark>. Ou seja, mais da metade não consegue.
            </p>
          </div>

          <p>
            Um estudo brasileiro publicado na Revista da Escola de Enfermagem da USP acompanhou mais de cem puérperas e encontrou uma relação direta entre o alinhamento do bebê durante a mamada e o risco de machucar o mamilo — o pescoço torcido, o queixo longe da mama e o lábio virado para dentro apareceram, repetidamente, ligados à dor.
          </p>

          <p className="font-extrabold text-[#5f448f] text-xl sm:text-2xl text-center">
            É justamente o que o Método PPS ensina a observar.
          </p>

        </div>
      </section>

      {/* SEÇÃO 07 — Visão/aspiração */}
      <section className="py-16 bg-[#fff5f7]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-6 text-gray-800 text-base sm:text-lg md:text-xl leading-relaxed">
          
          <p>
            Você já deve ter passado (ou está passando) meses se preparando: o enxoval certo, o quarto pronto, a mala da maternidade organizada, o carrinho escolhido depois de comparar dez modelos.
          </p>

          <p className="font-bold text-gray-900 text-lg sm:text-xl md:text-2xl">
            Mas e a amamentação? Aquilo que vai acontecer 8, 10, 12 vezes por dia, todos os dias, nos primeiros meses — você já sabe o que observar nela? Você já tem um plano claro para o sucesso do seu aleitamento?
          </p>

        </div>
      </section>

      {/* SEÇÃO 08 — Transição pessoal */}
      <section className="py-12 bg-[#5f448f] text-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight">
            Eu posso te ajudar a chegar lá. Vem comigo.
          </h3>
        </div>
      </section>

      {/* SEÇÃO 09 — Qualificação "para quem não é / para quem é" */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-12">
            Este programa é para você?
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
            
            {/* NÃO É PARA VOCÊ SE */}
            <div className="bg-red-50/70 border-2 border-red-200 rounded-3xl p-6 sm:p-8 flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-red-200">
                  <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
                    <X className="w-6 h-6 text-red-600" />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-extrabold text-red-900">
                    NÃO É PARA VOCÊ SE:
                  </h3>
                </div>

                <ul className="space-y-4">
                  <li className="flex items-start gap-3 text-gray-800 text-sm sm:text-base">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                    <span>Você está buscando uma fórmula mágica, sem aplicar nada na prática</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-800 text-sm sm:text-base">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                    <span>Você acredita que amamentação é instintiva e não exige preparo técnico</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-800 text-sm sm:text-base">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                    <span>Você acredita que amamentar não é tão importante e prefere comprar latas de fórmula</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-800 text-sm sm:text-base">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                    <span>Você quer só teoria e dicas soltas, sem técnica prática passo a passo</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* É PARA VOCÊ SE */}
            <div className="bg-green-50/70 border-2 border-green-200 rounded-3xl p-6 sm:p-8 flex flex-col justify-between shadow-lg">
              <div>
                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-green-200">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                    <Check className="w-6 h-6 text-green-700" />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-extrabold text-green-950">
                    É PARA VOCÊ SE:
                  </h3>
                </div>

                <ul className="space-y-4">
                  <li className="flex items-start gap-3 text-gray-900 font-medium text-sm sm:text-base">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <span>Você não abre mão de amamentar seu bebê com o único alimento espécie-específico — desenvolvido exatamente para as necessidades dele, que previne doenças e protege contra inúmeros males da infância</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-900 font-medium text-sm sm:text-base">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <span>Você está grávida e quer chegar ao parto sabendo o que observar — não descobrir no susto</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-900 font-medium text-sm sm:text-base">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <span>Você já é mãe, está com dor ou dificuldade agora, e quer resolver isso com técnica, não com palpite sem fundamento científico</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-900 font-medium text-sm sm:text-base">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <span>Você quer um método estruturado, validado pela experiência clínica de quem já acompanhou milhares de mães e desenhou técnicas sob medida para cada tipo de mãe, mama, mamilo e bebê</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-900 font-medium text-sm sm:text-base">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <span>Você quer se sentir segura nas suas decisões do início ao fim, com domínio de cada situação que surgir em cada fase do bebê, com estratégias e técnicas atualizadas</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* SEÇÃO 10 — Prova científica #1 */}
      <section className="py-16 md:py-20 bg-[#ebf7f7] border-y border-teal-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#3cacae]/15 text-[#2e8c8e] font-bold text-xs sm:text-sm uppercase tracking-wider mb-3">
              <BookOpen className="w-4 h-4" />
              <span>Evidência Científica</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900">
              A ciência por trás do Método PPS
            </h2>
          </div>

          <div className="space-y-6">
            
            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-sm border border-teal-100 flex items-start gap-4">
              <div className="w-8 h-8 rounded-full bg-[#3cacae]/10 text-[#3cacae] font-bold flex items-center justify-center flex-shrink-0 mt-1">
                1
              </div>
              <p className="text-gray-800 text-base sm:text-lg leading-relaxed">
                Uma pesquisa publicada na <strong>PNAS (Proceedings of the National Academy of Sciences)</strong> resolveu, com análise de ultrassom e modelo biofísico, um debate de mais de cem anos: é a sucção — a pressão de vácuo dentro da boca do bebê — que extrai o leite, e não a "ordenha" por compressão que muita gente imagina. Ou seja: pega e sucção são mecanicamente inseparáveis — exatamente a lógica do Método PPS.
              </p>
            </div>

            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-sm border border-teal-100 flex items-start gap-4">
              <div className="w-8 h-8 rounded-full bg-[#3cacae]/10 text-[#3cacae] font-bold flex items-center justify-center flex-shrink-0 mt-1">
                2
              </div>
              <p className="text-gray-800 text-base sm:text-lg leading-relaxed">
                Os quatro sinais de boa pega reconhecidos pela <strong>Organização Mundial da Saúde</strong> são: queixo do bebê tocando a mama (o que exige alinhamento perfeito), boca bem aberta, lábio inferior virado para fora e mais aréola visível acima do que abaixo da boca — sinais que, quando você sabe observar, tiram a decisão da mamada do "achismo".
              </p>
            </div>

            <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-sm border border-teal-100 flex items-start gap-4">
              <div className="w-8 h-8 rounded-full bg-[#3cacae]/10 text-[#3cacae] font-bold flex items-center justify-center flex-shrink-0 mt-1">
                3
              </div>
              <p className="text-gray-800 text-base sm:text-lg leading-relaxed">
                Um estudo publicado no <strong>International Breastfeeding Journal</strong>, com mais de 200 mulheres randomizadas, mostrou que ajustar o posicionamento durante a amamentação reduziu significativamente problemas mamários e rachaduras nos mamilos na alta da maternidade.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* SEÇÃO 11 — Transição */}
      <section className="py-12 bg-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <p className="text-xl sm:text-2xl md:text-3xl font-extrabold text-[#5f448f]">
            Tudo bem, a ciência explica o porquê. Mas será que, na prática, funciona mesmo?
          </p>
        </div>
      </section>

      {/* SEÇÃO 12 — Depoimentos (7 cards com prints reais) */}
      <section className="py-16 md:py-24 bg-[#f9fafb]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
              Depoimentos Reais de Mães
            </h2>
            <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
              Veja como o Método PPS transformou a história dessas famílias (relatos reais autorizados)
            </p>
          </div>

          {/* Grade organizada em 3 colunas com os 7 prints reais */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { id: "12-1", title: "Família Mesquitta", desc: "Resultado amamentação sem dor" },
              { id: "12-2", title: "Gestante (Pós-parto)", desc: "Segurança total no parto" },
              { id: "12-3", title: "Bruna Dos Santos Steffens", desc: "Avaliação Google — Fissura e dor resolvidas" },
              { id: "12-4", title: "Rebeca Talon", desc: "Avaliação Google — Disfunção oral e refluxo" },
              { id: "12-5", title: "@alinegalle", desc: "Pega perfeita no hospital" },
              { id: "12-6", title: "Gabriela", desc: "Livre demanda sem fissuras" },
              { id: "12-7", title: "Fernanda Maia", desc: "Head de Growth — Vitória do aleitamento exclusivo pós-UTI" }
            ].map((dep, idx) => (
              <div 
                key={idx} 
                className={`bg-white border border-gray-200 rounded-3xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col justify-between ${idx === 6 ? 'md:col-span-2 lg:col-span-1' : ''}`}
              >
                <div className="relative bg-gray-50 p-2">
                  <img 
                    src={`/depoimentos-selecionados/${dep.id}.jpg`} 
                    alt={`Depoimento Real - ${dep.title}`}
                    className="w-full h-auto object-cover rounded-2xl"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 bg-white border-t border-gray-100 flex items-center justify-between">
                  <div>
                    <h4 className="font-extrabold text-gray-900 text-sm">{dep.title}</h4>
                    <p className="text-xs text-gray-500">{dep.desc}</p>
                  </div>
                  <div className="flex text-[#facc15]">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-3.5 h-3.5 fill-current" />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEÇÃO 13 — Mecanismo (Método PPS) */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
              Estratégias isoladas são um risco para você e seu bebê
            </h2>
            <div className="text-xl sm:text-2xl font-bold text-[#5f448f] mt-4">
              Essas são as 3 letras que protegem cada mamada: P. P. S.
            </div>
            <p className="text-lg font-semibold text-[#a54d9e] mt-2">
              Posição, Pega e Sucção — e a amamentação deixa de ser uma incógnita.
            </p>
          </div>

          {/* Destaque com Desenho da Engrenagem Conectada */}
          <div className="bg-[#fff5f7] p-6 sm:p-8 md:p-10 rounded-3xl border border-pink-200 mb-12 text-gray-800 text-base sm:text-lg leading-relaxed shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-7 space-y-4">
                <p className="font-medium">
                  Informação solta sobre amamentação não é preparação. Vídeo de pega, dica de posição, print de grupo de mães, dica de conchas, canjica, chás — cada peça isolada parece ajudar, mas <mark className="bg-[#facc15] text-[#111827] font-extrabold px-1.5 py-0.5 rounded">sem uma estrutura que conecte tudo, você continua sem saber, na prática, se a mamada do seu bebê está funcionando</mark> e onde está a raiz real do problema.
                </p>
              </div>

              {/* Diagrama de Engrenagem PPS */}
              <div className="lg:col-span-5 flex flex-col items-center justify-center p-6 bg-white rounded-2xl border-2 border-purple-100 shadow-md">
                <div className="relative w-52 h-52 flex items-center justify-center">
                  {/* Engrenagem 1 - Posição */}
                  <div className="absolute top-2 left-2 text-[#5f448f] animate-spin" style={{ animationDuration: '12s' }}>
                    <Cog className="w-24 h-24" />
                  </div>
                  <div className="absolute top-9 left-4 bg-[#5f448f] text-white font-extrabold text-xs px-3 py-1 rounded-full shadow-md z-10 border border-white tracking-wide">
                    POSIÇÃO
                  </div>

                  {/* Engrenagem 2 - Pega */}
                  <div className="absolute top-14 right-2 text-[#a54d9e] animate-spin" style={{ animationDuration: '10s', animationDirection: 'reverse' }}>
                    <Cog className="w-20 h-20" />
                  </div>
                  <div className="absolute top-[72px] right-4 bg-[#a54d9e] text-white font-extrabold text-xs px-3 py-1 rounded-full shadow-md z-10 border border-white tracking-wide">
                    PEGA
                  </div>

                  {/* Engrenagem 3 - Sucção */}
                  <div className="absolute bottom-2 left-10 text-[#3cacae] animate-spin" style={{ animationDuration: '14s' }}>
                    <Cog className="w-24 h-24" />
                  </div>
                  <div className="absolute bottom-9 left-11 bg-[#3cacae] text-white font-extrabold text-xs px-3 py-1 rounded-full shadow-md z-10 border border-white tracking-wide">
                    SUCÇÃO
                  </div>
                </div>

                <div className="mt-4 text-center">
                  <span className="inline-block px-4 py-1.5 bg-gradient-to-r from-[#5f448f] to-[#a54d9e] text-white font-extrabold text-xs rounded-full shadow">
                    ENGRENAGEM PERFEITA — MÉTODO PPS
                  </span>
                  <p className="text-xs text-gray-500 mt-1 font-medium">
                    (Posição → Pega → Sucção funcionando juntas)
                  </p>
                </div>
              </div>

            </div>
          </div>

          <p className="text-center font-bold text-gray-900 text-lg sm:text-xl mb-10">
            O Método PPS organiza o seu olhar em três etapas que se conectam, uma dependendo diretamente da outra:
          </p>

          {/* Componente Proprietário Método PPS (P - P - S) */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
            
            {/* Card P - Posição */}
            <div className="bg-gradient-to-b from-[#faf5ff] to-white p-6 sm:p-8 rounded-3xl border-2 border-[#5f448f] shadow-lg flex flex-col justify-between relative">
              <div className="absolute -top-4 left-6 bg-[#5f448f] text-white font-extrabold text-lg px-4 py-1 rounded-full">
                P 1
              </div>
              <div className="mt-4">
                <h3 className="text-2xl font-extrabold text-[#5f448f] mb-3">POSIÇÃO</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  O alinhamento correto entre o corpo do bebê e o seu corpo. É a base de tudo: sem posição adequada, a pega correta simplesmente não acontece.
                </p>
              </div>
            </div>

            {/* Card P - Pega */}
            <div className="bg-gradient-to-b from-[#fff5f7] to-white p-6 sm:p-8 rounded-3xl border-2 border-[#a54d9e] shadow-lg flex flex-col justify-between relative">
              <div className="absolute -top-4 left-6 bg-[#a54d9e] text-white font-extrabold text-lg px-4 py-1 rounded-full">
                P 2
              </div>
              <div className="mt-4">
                <h3 className="text-2xl font-extrabold text-[#a54d9e] mb-3">PEGA</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Vai muito além da "boca de peixinho". O bebê precisa abocanhar a aréola — não só o mamilo —, criar um vácuo intraoral e se encaixar na região certa da mama para extrair leite com eficiência.
                </p>
              </div>
            </div>

            {/* Card S - Sucção */}
            <div className="bg-gradient-to-b from-[#ebf7f7] to-white p-6 sm:p-8 rounded-3xl border-2 border-[#3cacae] shadow-lg flex flex-col justify-between relative">
              <div className="absolute -top-4 left-6 bg-[#3cacae] text-white font-extrabold text-lg px-4 py-1 rounded-full">
                S 3
              </div>
              <div className="mt-4">
                <h3 className="text-2xl font-extrabold text-[#3cacae] mb-3">SUCÇÃO</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Uma boa pega permite a sucção efetiva, que garante uma boa transferência de leite — o estímulo que avisa o seu corpo para liberar o hormônio responsável por "descer o leite". Quanto mais eficiente a sucção, mais o bebê mama, mais ganha peso, e mais sua produção se mantém — porque é uma lógica de oferta e demanda.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* SEÇÃO 14 — Estratégias isoladas */}
      <section className="py-16 bg-[#fff5f7]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-6 text-gray-800 text-base sm:text-lg md:text-xl leading-relaxed">
          
          <p>
            Você provavelmente já viu dezenas de vídeos soltos sobre amamentação, já entrou em grupos de mães no WhatsApp, já ouviu opiniões diferentes de familiares, amigas, até de profissionais diferentes.
          </p>

          <p>
            Cada peça de informação, sozinha, parece fazer sentido — mas sem conectar Posição, Pega e Sucção como uma engrenagem, você continua tentando adivinhar o que está funcionando e o que não está.
          </p>

          <div className="p-6 bg-white rounded-2xl border-l-4 border-[#a54d9e] shadow-sm font-semibold text-gray-900">
            E isso não é preparação. É informação solta que gera confusão, não segurança.
          </div>

        </div>
      </section>

      {/* SEÇÃO 15 — Payoff */}
      <section className="py-16 bg-[#faf5ff]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center space-y-6">
          <p className="text-lg sm:text-xl md:text-2xl text-gray-900 font-bold leading-relaxed">
            Quando você aprende a observar as três etapas juntas — não isoladas —, a mamada deixa de ser um mistério. Você passa a saber, mamada após mamada, se o que está acontecendo é esperado ou se merece ajuste.
          </p>
        </div>
      </section>

      {/* SEÇÃO 16 — CTA repetido */}
      <section className="py-12 bg-white text-center">
        <div className="max-w-4xl mx-auto px-4">
          <button
            onClick={scrollToOffer}
            className="w-full sm:w-auto bg-[#5f448f] hover:bg-[#a54d9e] text-white font-extrabold text-lg sm:text-xl py-4 px-8 md:px-12 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center gap-3 border-b-4 border-[#4a3371] mx-auto"
          >
            <span>Quero uma amamentação exclusiva e sem dor</span>
            <ArrowRight className="w-6 h-6" />
          </button>
        </div>
      </section>

      {/* SEÇÃO 17 — "O que você vai aprender" (8 blocos) */}
      <section className="py-16 md:py-24 bg-white border-t border-gray-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
              O que você vai aprender
            </h2>
            <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
              Conhecimento prático, direto ao ponto e validado em 25 anos de prática clínica
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            
            {/* Bloco 1 */}
            <div className="bg-[#faf5ff] p-6 sm:p-8 rounded-3xl border border-purple-100">
              <h3 className="text-xl sm:text-2xl font-extrabold text-[#5f448f] mb-3">
                O Método PPS Completo
              </h3>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                Vou te mostrar, na prática, como alinhar Posição, Pega e Sucção desde a primeira mamada, com demonstrações reais, gravadas com mães e bebês de verdade, pra você enxergar cada detalhe que separa uma mamada confortável de uma mamada dolorida.
              </p>
            </div>

            {/* Bloco 2 */}
            <div className="bg-[#fff5f7] p-6 sm:p-8 rounded-3xl border border-pink-100">
              <h3 className="text-xl sm:text-2xl font-extrabold text-[#c46bbb] mb-3">
                A Rotina Real da Amamentação
              </h3>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                Você vai aprender a reconhecer os sinais de fome do seu bebê (isso é o que dita o comportamento dele ao seio, e quase ninguém ensina sobre isso), entender como funciona a livre demanda na prática e atravessar as primeiras semanas — inclusive as noites — sabendo o que é esperado e o que pode ser ajustado.
              </p>
            </div>

            {/* Bloco 3 */}
            <div className="bg-[#ebf7f7] p-6 sm:p-8 rounded-3xl border border-teal-100">
              <h3 className="text-xl sm:text-2xl font-extrabold text-[#3cacae] mb-3">
                Seu Tipo de Mama e Mamilo, Sem Generalizações
              </h3>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                Mama grande, pequena, mamilo plano, invertido, prótese, pós-mastectomia: cada corpo pede um ajuste diferente na hora de amamentar. Você vai aprender exatamente o que muda no seu caso, sem depender de dicas genéricas que só funcionam "às vezes".
              </p>
            </div>

            {/* Bloco 4 */}
            <div className="bg-purple-50 p-6 sm:p-8 rounded-3xl border border-purple-100">
              <h3 className="text-xl sm:text-2xl font-extrabold text-[#a54d9e] mb-3">
                Como Agir em Situações Específicas do Seu Bebê
              </h3>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                Prematuridade, baixo peso, cólica, icterícia, refluxo, disfunções orais: são situações que geram insegurança justamente porque ninguém te preparou pra elas. Aqui você vai entender o que observar em cada uma, com calma, sem pânico e sem pôr a amamentação em risco.
              </p>
            </div>

            {/* Bloco 5 */}
            <div className="bg-pink-50 p-6 sm:p-8 rounded-3xl border border-pink-100">
              <h3 className="text-xl sm:text-2xl font-extrabold text-[#5f448f] mb-3">
                O Que Fazer Quando a Mamada Dói ou Algo Parece Errado
              </h3>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                Dor, fissura, ingurgitamento, sinais de mastite, baixa produção de leite: você vai aprender a reconhecer cada sinal cedo — muitas vezes antes que vire um problema maior — e a agir com técnica, não com desespero ou palpite de última hora.
              </p>
            </div>

            {/* Bloco 6 */}
            <div className="bg-teal-50 p-6 sm:p-8 rounded-3xl border border-teal-100">
              <h3 className="text-xl sm:text-2xl font-extrabold text-[#2e8c8e] mb-3">
                Mão na Massa: Técnicas Práticas, Passo a Passo
              </h3>
              <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                Massagens, compressas, extração, ordenha e armazenamento do leite materno: tudo demonstrado do jeito que dá pra reproduzir sozinha, em casa, sem precisar de equipamento caro ou ajuda especializada o tempo todo.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* SEÇÃO 18 — "Para quem é" — qualificação estendida (10 bullets) */}
      <section className="py-16 bg-[#faf5ff]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-10">
            Este treinamento é para:
          </h2>

          <div className="bg-white p-6 sm:p-10 rounded-3xl shadow-lg border border-purple-100 space-y-5">
            {[
              "Você está grávida e quer chegar ao parto sabendo o que observar, não descobrir na hora",
              "Você já é mãe e está sentindo dor a cada mamada, e não aguenta mais esperar pra resolver",
              "Seu bebê solta o peito e chora, e você não sabe se é fome, cólica ou pega errada",
              "Você tem mamas grandes, pequenas, mamilos planos ou invertidos, prótese ou já fez mastectomia, e quer saber como isso muda (ou não muda) sua amamentação",
              "Seu bebê nasceu prematuro, com baixo peso, ou precisou ficar internado, e você precisa de orientação específica",
              "Você já ouviu opiniões diferentes de dez pessoas diferentes e não sabe mais em quem confiar",
              "Você tem medo de seu bebê estar \"passando fome\"",
              "Você já teve (ou está tendo) rachadura, ingurgitamento ou suspeita de mastite, e quer aprender a agir antes que piore",
              "Você quer entender o sono do bebê ligado à amamentação, sem depender de fórmulas prontas de internet",
              "Você quer autonomia pra reconhecer, sozinha, quando é hora de procurar ajuda profissional"
            ].map((bullet, idx) => (
              <div key={idx} className="flex items-start gap-4 p-2 rounded-xl hover:bg-purple-50/50 transition-colors">
                <CheckCircle2 className="w-6 h-6 text-[#5f448f] flex-shrink-0 mt-0.5" />
                <span className="text-gray-800 text-base sm:text-lg font-medium leading-snug">
                  {bullet}
                </span>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* SEÇÃO 19 — Autoridade — bio da especialista */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            
            {/* Foto Retrato Profissional Rosane */}
            <div className="lg:col-span-5 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-tr from-[#5f448f] to-[#c46bbb] rounded-3xl transform rotate-3 scale-105 opacity-20" />
                <img 
                  src="/lovable-uploads/cf978e16-cc7f-4926-84e7-12e94ef564c1.png" 
                  alt="Rosane Baldissera - Especialista em Amamentação" 
                  className="relative z-10 rounded-3xl shadow-2xl max-w-full h-auto object-cover border-4 border-white"
                />
              </div>
            </div>

            {/* Conteúdo Bio */}
            <div className="lg:col-span-7 space-y-6">
              <div>
                <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-2">
                  Rosane Baldissera
                </h2>
                <p className="text-base sm:text-lg font-bold text-[#5f448f] leading-snug">
                  Nutricionista Materno Infantil · Consultora Internacional em Amamentação (IBCLC) · Mestre em Saúde da Criança
                </p>
              </div>

              <div className="space-y-4 text-gray-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Há 25 anos, Rosane acompanha mães em um dos momentos mais delicados da maternidade: os primeiros dias de amamentação. Já são mais de 15.000 duplas mãe-bebê transformadas e mais de 2.000 profissionais de saúde formados por ela com o Método PPS em todo o Brasil.
                </p>

                <p>
                  Rosane também é mãe do Felipe, que ela mesma amamentou exclusivamente, sem dificuldades — e é justamente essa experiência, somada à formação técnica, que deu origem ao Método PPS: uma forma de traduzir décadas de prática clínica em algo que qualquer mãe consiga aplicar em casa.
                </p>

                <p>
                  Rosane já levou esse conhecimento para programas de TV e para grandes veículos como o UOL, sempre com o mesmo objetivo: tirar a amamentação do campo do improviso e do instinto.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* SEÇÃO 20 — Módulos do treinamento (currículo detalhado em 3 fases) */}
      <section className="py-16 md:py-24 bg-[#f9fafb]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
              Módulos do Treinamento
            </h2>
            <p className="text-gray-600 text-base sm:text-lg">
              Estrutura completa em 3 fases progressivas para a sua jornada
            </p>
          </div>

          <div className="space-y-10">
            
            {/* FASE 1 */}
            <div className="bg-white p-6 sm:p-8 rounded-3xl shadow-md border border-purple-100">
              <div className="inline-block bg-[#5f448f] text-white font-extrabold text-sm sm:text-base px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider">
                FASE 1 — PREPARO (Módulos 1-3)
              </div>
              <div className="space-y-6">
                
                <div className="border-l-4 border-[#5f448f] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 1 — Fatores que Influenciam a Amamentação
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Como a amamentação funciona como processo de aprendizado, os benefícios reais do aleitamento, a anatomia da mama e dos mamilos, as questões emocionais do puerpério e como montar sua rede de apoio.
                  </p>
                </div>

                <div className="border-l-4 border-[#5f448f] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 2 — Método PPS: Posição, Pega e Sucção
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    O núcleo do curso. Posição da mãe e do bebê em diferentes situações, técnicas de amolecimento da aréola, técnica do sanduíche, pega correta passo a passo, como identificar e ajustar uma pega incorreta, e sucção efetiva na prática.
                  </p>
                </div>

                <div className="border-l-4 border-[#5f448f] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 3 — Rotinas da Amamentação e do Bebê
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Primeiras horas de vida, apojadura, sinais de fome, como acalmar o bebê para mamar, livre demanda, amamentação noturna e de gêmeos, e a "hora da bruxa".
                  </p>
                </div>

              </div>
            </div>

            {/* FASE 2 */}
            <div className="bg-white p-6 sm:p-8 rounded-3xl shadow-md border border-pink-100">
              <div className="inline-block bg-[#a54d9e] text-white font-extrabold text-sm sm:text-base px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider">
                FASE 2 — MANEJO (Módulos 4-6)
              </div>
              <div className="space-y-6">
                
                <div className="border-l-4 border-[#a54d9e] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 4 — Situações Específicas da Nutriz e do Bebê
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Mamas grandes, pendulares, prótese, mastectomia; mamilos planos, invertidos; bebês PIG/GIG, prematuros, com cólica, icterícia, refluxo, alergia à proteína do leite de vaca ou baixo ganho de peso.
                  </p>
                </div>

                <div className="border-l-4 border-[#a54d9e] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 5 — Dificuldades na Amamentação
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Atraso na descida do leite, dor, lesões mamilares, ingurgitamento, bloqueio de ductos, mastite, abscesso, candidíase, Raynaud, DMER, hiperlactação, hipogalactia e recusa do seio.
                  </p>
                </div>

                <div className="border-l-4 border-[#a54d9e] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 6 — Técnicas Práticas para Resolução das Dificuldades
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Ativação do reflexo de ejeção, extração de alívio, massagens e compressas, compressão mamária, translactação/relactação, extração manual e protocolos de ordenha.
                  </p>
                </div>

              </div>
            </div>

            {/* FASE 3 */}
            <div className="bg-white p-6 sm:p-8 rounded-3xl shadow-md border border-teal-100">
              <div className="inline-block bg-[#3cacae] text-white font-extrabold text-sm sm:text-base px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider">
                FASE 3 — AUTONOMIA (Módulos 7-10)
              </div>
              <div className="space-y-6">
                
                <div className="border-l-4 border-[#3cacae] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 7 — Produtos, Dispositivos e Equipamentos
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Poltrona, conchas, pomadas, absorventes, coletores, bombas extratoras, recipientes de armazenamento, chupeta e mamadeira (paced feeding).
                  </p>
                </div>

                <div className="border-l-4 border-[#3cacae] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 8 — Dúvidas Frequentes da Nutriz
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Preparo das mamas na gestação, alimentação, medicamentos, consumo de álcool, uso de anticoncepcional, nova gravidez durante a amamentação, estado emocional e mais.
                  </p>
                </div>

                <div className="border-l-4 border-[#3cacae] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 9 — Cuidados com o Recém-Nascido
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Necessidades do RN, como fazer arrotar, desengasgar, identificar e aliviar cólicas, exterogestação.
                  </p>
                </div>

                <div className="border-l-4 border-[#3cacae] pl-4">
                  <h3 className="font-extrabold text-lg sm:text-xl text-gray-900 mb-2">
                    Módulo 10 — Sono do Recém-Nascido
                  </h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    Como o sono do bebê se conecta com a amamentação, e como ensinar seu bebê a dormir com um método gentil, sem interferir na amamentação.
                  </p>
                </div>

              </div>
            </div>

          </div>

        </div>
      </section>

      {/* SEÇÃO 21 — Prova científica #2 (reforço em estilo Notícia/Imprensa) */}
      <section className="py-16 md:py-24 bg-[#f8fafc] border-y border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-900 text-white font-extrabold text-xs sm:text-sm uppercase tracking-wider mb-3">
              <Newspaper className="w-4 h-4 text-[#facc15]" />
              <span>Destaques Científicos & Notícias</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900">
              Mais evidências científicas sobre a importância da técnica
            </h2>
          </div>

          <div className="space-y-6">
            
            {/* Notícia 1 */}
            <div className="bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden hover:shadow-xl transition-all">
              <div className="bg-slate-900 text-white px-6 py-2.5 flex items-center justify-between text-xs font-bold uppercase tracking-wider">
                <span className="flex items-center gap-2">
                  <FileText className="w-4 h-4 text-[#3cacae]" />
                  Birth Journal — Publicação Científica
                </span>
                <span className="text-slate-400">Estudo de Campo</span>
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-lg sm:text-xl font-extrabold text-gray-900 mb-3 leading-snug">
                  "Corrigir precocemente a técnica de sucção equipara o sucesso da amamentação ao de mães sem dificuldades"
                </h3>
                <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                  Um estudo publicado no <strong>Birth Journal</strong> acompanhou 82 duplas mãe-bebê e mostrou que corrigir precocemente a técnica de sucção equiparou o desfecho da amamentação ao de mães que já tinham a técnica correta desde o início — ou seja, dá tempo de corrigir, mesmo depois que a dificuldade já apareceu.
                </p>
              </div>
            </div>

            {/* Notícia 2 */}
            <div className="bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden hover:shadow-xl transition-all">
              <div className="bg-[#5f448f] text-white px-6 py-2.5 flex items-center justify-between text-xs font-bold uppercase tracking-wider">
                <span className="flex items-center gap-2">
                  <FileText className="w-4 h-4 text-[#facc15]" />
                  Revista da Escola de Enfermagem da USP
                </span>
                <span className="text-purple-200">Pesquisa Nacional</span>
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-lg sm:text-xl font-extrabold text-gray-900 mb-3 leading-snug">
                  "Orientação no pré-natal aumenta significativamente a confiança e as taxas de aleitamento exclusivo"
                </h3>
                <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                  Uma pesquisa brasileira publicada na <strong>Revista da Escola de Enfermagem da USP</strong>, com gestantes no terceiro trimestre, encontrou diferença estatisticamente significativa na confiança para amamentar e nas taxas de amamentação exclusiva entre quem recebeu orientação ainda na gestação e quem não recebeu.
                </p>
              </div>
            </div>

            {/* Notícia 3 */}
            <div className="bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden hover:shadow-xl transition-all">
              <div className="bg-slate-900 text-white px-6 py-2.5 flex items-center justify-between text-xs font-bold uppercase tracking-wider">
                <span className="flex items-center gap-2">
                  <FileText className="w-4 h-4 text-[#3cacae]" />
                  JAMA Pediatrics (Amitay & Keinan-Boker)
                </span>
                <span className="text-slate-400">Meta-análise (18 Estudos)</span>
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-lg sm:text-xl font-extrabold text-gray-900 mb-3 leading-snug">
                  "Amamentar por 6 meses ou mais está associado a 19% menos risco de leucemia infantil"
                </h3>
                <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                  Uma meta-análise publicada na <strong>JAMA Pediatrics (Amitay & Keinan-Boker, 2015)</strong>, reunindo 18 estudos, mostrou que amamentar por 6 meses ou mais está associado a 19% menos risco de leucemia infantil — os pesquisadores estimam que entre 14% e 19% dos casos de leucemia na infância poderiam ser evitados com a amamentação.
                </p>
              </div>
            </div>

            {/* Notícia 4 */}
            <div className="bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden hover:shadow-xl transition-all">
              <div className="bg-[#a54d9e] text-white px-6 py-2.5 flex items-center justify-between text-xs font-bold uppercase tracking-wider">
                <span className="flex items-center gap-2">
                  <FileText className="w-4 h-4 text-[#facc15]" />
                  Acta Paediatrica (Horta et al.)
                </span>
                <span className="text-pink-100">Desenvolvimento Cognitivo</span>
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-lg sm:text-xl font-extrabold text-gray-900 mb-3 leading-snug">
                  "Crianças amamentadas apresentam maior pontuação em desenvolvimento cognitivo e QI"
                </h3>
                <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                  Uma meta-análise publicada na <strong>Acta Paediatrica (Horta et al., 2015)</strong> encontrou uma diferença média de 3,44 pontos de QI a favor de crianças amamentadas — diferença que se mantém (2,62 pontos) mesmo quando o estudo controla estatisticamente pela inteligência da própria mãe, o que reforça que o efeito não é apenas genético.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* SEÇÃO 22 — Intro bônus */}
      <section className="py-12 bg-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-pink-100 text-[#a54d9e] font-bold text-xs sm:text-sm uppercase tracking-wider mb-3">
            <Gift className="w-4 h-4" />
            <span>Presentes Exclusivos</span>
          </div>
          <h3 className="text-2xl sm:text-3xl font-extrabold text-[#5f448f]">
            E, se você se inscrever agora, ainda leva 5 bônus completos, sem custo adicional.
          </h3>
        </div>
      </section>

      {/* SEÇÃO 23 — CTA repetido */}
      <section className="py-8 bg-white text-center">
        <div className="max-w-4xl mx-auto px-4">
          <button
            onClick={scrollToOffer}
            className="w-full sm:w-auto bg-[#5f448f] hover:bg-[#a54d9e] text-white font-extrabold text-lg sm:text-xl py-4 px-8 md:px-12 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center gap-3 border-b-4 border-[#4a3371] mx-auto"
          >
            <span>Quero uma amamentação exclusiva e sem dor</span>
            <ArrowRight className="w-6 h-6" />
          </button>
        </div>
      </section>

      {/* SEÇÃO 24 — Stack de bônus (5 cards) */}
      <section className="py-16 md:py-24 bg-[#faf5ff]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
            
            {/* Bonus 1 */}
            <div className="bg-white p-6 rounded-3xl shadow-md border border-purple-100 flex flex-col justify-between">
              <div>
                <span className="text-xs font-bold text-white bg-[#5f448f] px-3 py-1 rounded-full uppercase tracking-wider">
                  Bônus 1
                </span>
                <h4 className="text-xl font-extrabold text-gray-900 mt-4 mb-2">
                  Protocolo AME
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Como extrair, armazenar e ofertar leite materno ao seu bebê sem colocar a amamentação em risco.
                </p>
              </div>
              <div className="pt-4 border-t border-gray-100 flex items-center justify-between text-sm">
                <span className="text-gray-400 line-through">De R$97,00</span>
                <span className="font-extrabold text-[#22c55e] text-base">por GRÁTIS</span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white p-6 rounded-3xl shadow-md border border-purple-100 flex flex-col justify-between">
              <div>
                <span className="text-xs font-bold text-white bg-[#a54d9e] px-3 py-1 rounded-full uppercase tracking-wider">
                  Bônus 2
                </span>
                <h4 className="text-xl font-extrabold text-gray-900 mt-4 mb-2">
                  Técnicas para o Seu Tipo de Mama
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Orientações específicas e práticas para mamas grandes, pequenas, caídas, mamilos invertidos ou planos.
                </p>
              </div>
              <div className="pt-4 border-t border-gray-100 flex items-center justify-between text-sm">
                <span className="text-gray-400 line-through">De R$147,00</span>
                <span className="font-extrabold text-[#22c55e] text-base">por GRÁTIS</span>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white p-6 rounded-3xl shadow-md border border-purple-100 flex flex-col justify-between">
              <div>
                <span className="text-xs font-bold text-white bg-[#3cacae] px-3 py-1 rounded-full uppercase tracking-wider">
                  Bônus 3
                </span>
                <h4 className="text-xl font-extrabold text-gray-900 mt-4 mb-2">
                  Protocolo Enxoval
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Descubra quais produtos, dispositivos e equipamentos você deve — e não precisa — adquirir.
                </p>
              </div>
              <div className="pt-4 border-t border-gray-100 flex items-center justify-between text-sm">
                <span className="text-gray-400 line-through">De R$97,00</span>
                <span className="font-extrabold text-[#22c55e] text-base">por GRÁTIS</span>
              </div>
            </div>

            {/* Bonus 4 */}
            <div className="bg-white p-6 rounded-3xl shadow-md border border-purple-100 flex flex-col justify-between">
              <div>
                <span className="text-xs font-bold text-white bg-[#c46bbb] px-3 py-1 rounded-full uppercase tracking-wider">
                  Bônus 4
                </span>
                <h4 className="text-xl font-extrabold text-gray-900 mt-4 mb-2">
                  Cuidados com o Recém-Nascido
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Como fazer o bebê arrotar, desengasgar, acalmar e aliviar cólicas.
                </p>
              </div>
              <div className="pt-4 border-t border-gray-100 flex items-center justify-between text-sm">
                <span className="text-gray-400 line-through">De R$67,00</span>
                <span className="font-extrabold text-[#22c55e] text-base">por GRÁTIS</span>
              </div>
            </div>

            {/* Bonus 5 */}
            <div className="bg-white p-6 rounded-3xl shadow-md border border-purple-100 flex flex-col justify-between md:col-span-2 lg:col-span-1">
              <div>
                <span className="text-xs font-bold text-white bg-[#5f448f] px-3 py-1 rounded-full uppercase tracking-wider">
                  Bônus 5
                </span>
                <h4 className="text-xl font-extrabold text-gray-900 mt-4 mb-2">
                  Sono do Bebê
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Como fazer seu bebê dormir melhor, sem deixar chorando.
                </p>
              </div>
              <div className="pt-4 border-t border-gray-100 flex items-center justify-between text-sm">
                <span className="text-gray-400 line-through">De R$197,00</span>
                <span className="font-extrabold text-[#22c55e] text-base">por GRÁTIS</span>
              </div>
            </div>

          </div>

          <div className="bg-[#5f448f] text-white p-6 rounded-2xl text-center shadow-lg font-extrabold text-lg sm:text-xl">
            Valor total em bônus: R$605,00 — inclusos sem custo adicional.
          </div>

        </div>
      </section>

      {/* SEÇÃO 25 — Oferta (plano único) */}
      <section id="oferta" className="py-16 md:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
              Garanta sua vaga no curso
            </h2>
            <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
              Aproveite a condição especial e comece agora mesmo
            </p>
          </div>

          <div className="max-w-2xl mx-auto bg-gradient-to-b from-[#faf5ff] to-white border-2 border-[#5f448f] rounded-3xl p-6 sm:p-8 flex flex-col justify-between shadow-xl hover:shadow-2xl transition-all mb-12 relative">
            <div>
              <div className="text-center border-b border-purple-100 pb-6 mb-6">
                <h3 className="text-2xl sm:text-3xl font-extrabold text-[#5f448f] mb-2">
                  Curso Completo
                </h3>
                <div className="text-gray-400 text-base line-through">
                  {priceFrom}
                </div>
                <div className="text-4xl sm:text-5xl font-extrabold text-[#5f448f] my-2">
                  {priceMain}
                </div>
                <div className="text-sm font-semibold text-gray-600">
                  {priceInstallments}
                </div>
              </div>

              <div className="space-y-4 mb-8">
                <p className="font-bold text-[#5f448f] text-sm uppercase tracking-wider">O que você vai receber:</p>
                
                <div className="flex items-start gap-3 text-sm text-gray-800">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Acesso completo aos 10 módulos (mais de 100 aulas, com mães e bebês reais)</span>
                </div>

                <div className="flex items-start gap-3 text-sm text-gray-800">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Método PPS completo — Posição, Pega e Sucção</span>
                </div>

                <div className="flex items-start gap-3 text-sm text-gray-800">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Suporte especializado na área de membros</span>
                </div>

                <div className="flex items-start gap-3 text-sm text-gray-800">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>5 bônus exclusivos</span>
                </div>

                <div className="flex items-start gap-3 text-sm text-gray-800">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>1 ano de acesso à plataforma</span>
                </div>

                <div className="flex items-start gap-3 text-sm text-gray-800">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <span>Garantia incondicional de 7 dias</span>
                </div>
              </div>
            </div>

            <a
              href={getCheckoutUrlWithUtms(checkoutUrl)}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold text-base sm:text-lg py-4 px-6 rounded-2xl transition-all duration-300 text-center shadow-xl flex items-center justify-center gap-2 transform hover:scale-105"
            >
              <span>Quero uma amamentação exclusiva e sem dor</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          {/* Texto compartilhado de oportunidade WhatsApp */}
          <div className="p-6 bg-[#fff5f7] rounded-3xl border border-pink-200 text-center max-w-3xl mx-auto shadow-sm">
            <p className="text-gray-800 font-medium text-sm sm:text-base leading-relaxed">
              "Na próxima página, você também vai ter acesso a uma oportunidade única: a Comunidade Amamentação na Prática no WhatsApp, com contato direto com a Rosane. Essa entrada só existe nesse momento, não tem outra forma de acessar depois."
            </p>
          </div>

        </div>
      </section>

      {/* SEÇÃO 26 — Suporte pré-venda */}
      <section className="py-12 bg-[#ebf7f7]">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-4">
          <p className="text-xl sm:text-2xl font-bold text-gray-900">
            Ainda com alguma dúvida? Fale com nosso time antes de decidir.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20ba5a] text-white font-extrabold text-base sm:text-lg py-3.5 px-8 rounded-2xl shadow-lg transition-all duration-300 transform hover:scale-105"
          >
            <MessageCircle className="w-6 h-6" />
            <span>Falar no WhatsApp</span>
          </a>
        </div>
      </section>

      {/* SEÇÃO 27 — Resultados / Mais resultados (grade de prints) */}
      <section className="py-16 md:py-24 bg-white overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3">
              Mais Resultados
            </h2>
            <p className="text-gray-600 text-base sm:text-lg max-w-xl mx-auto">
              Relatos reais de quem transformou a amamentação com o Método PPS
            </p>
          </div>

          {/* Grade estilo Mosaico/Masonry */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { id: "27-1", desc: "@starsoares, fala direto com quem está grávida agora", rot: "rotate-1" },
              { id: "27-2", desc: "Compilado de avaliações Google, inclui menção a amamentar sem dor na 4ª filha", rot: "-rotate-2" },
              { id: "27-3", desc: "Cecília mamando após ajuste de posição e pega", rot: "rotate-2" },
              { id: "27-4", desc: "Preparo antes do nascimento, zero fissura/mastite", rot: "-rotate-1" },
              { id: "27-5", desc: "Bianca Schorn, dermatologista, endosso profissional", rot: "rotate-3" },
              { id: "27-6", desc: "Isa, 3 anos e 4 meses amamentando", rot: "-rotate-3" },
              { id: "27-7", desc: "Depoimento sobre conteúdo gratuito (se o gratuito já transforma, imagina o curso)", rot: "rotate-1" },
              { id: "27-8", desc: "Mariane Oliveira — Relato aluna", rot: "-rotate-2" },
              { id: "27-9", desc: "Relato resolvido com consultoria remota", rot: "rotate-2" },
              { id: "27-10", desc: "Compilado de stories curtos", rot: "-rotate-1" },
              { id: "27-11", desc: "meu curso é meu Google", rot: "rotate-1" }
            ].map((print, idx) => (
              <div 
                key={idx} 
                className={`bg-gray-50 border border-gray-200 rounded-2xl overflow-hidden shadow-md transition-all duration-300 hover:shadow-xl hover:scale-105 hover:rotate-0 transform ${print.rot} flex flex-col justify-between`}
              >
                <div className="relative">
                  <img 
                    src={`/depoimentos-selecionados/${print.id}.jpg`} 
                    alt={`Resultado Método PPS - ${print.desc}`}
                    className="w-full h-auto object-cover"
                    onError={(e) => {
                      // Fallback visual limpo mantendo a estrutura sem imagem quebrada
                      e.currentTarget.style.display = 'none';
                      const parent = e.currentTarget.parentElement;
                      if (parent) {
                        const fallback = document.createElement('div');
                        fallback.className = 'p-6 bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-dashed border-purple-200 text-center rounded-xl my-2 mx-2';
                        fallback.innerHTML = `<div class="text-xs font-bold text-[#5f448f] uppercase mb-1">Print ${print.id}</div><p class="text-xs text-gray-600 italic">[ASSET NECESSÁRIO: ${print.desc}]</p>`;
                        parent.appendChild(fallback);
                      }
                    }}
                  />
                </div>
                <div className="p-3 bg-white text-xs font-medium text-gray-500 border-t border-gray-100 flex items-center justify-between">
                  <span>Mural de Resultados</span>
                  <Instagram className="w-3.5 h-3.5 text-[#a54d9e]" />
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* SEÇÃO 28 — Garantia */}
      <section className="py-16 md:py-20 bg-[#faf5ff]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="bg-white p-8 sm:p-12 rounded-3xl shadow-xl border-2 border-purple-200 flex flex-col md:flex-row items-center gap-8 text-center md:text-left">
            
            <div className="w-28 h-28 rounded-full bg-gradient-to-tr from-[#5f448f] to-[#c46bbb] text-white flex flex-col items-center justify-center flex-shrink-0 shadow-lg border-4 border-white">
              <ShieldCheck className="w-10 h-10 mb-1" />
              <span className="font-extrabold text-xs uppercase tracking-wider">7 Dias</span>
              <span className="text-[10px]">Garantia</span>
            </div>

            <div className="space-y-4">
              <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
                Risco zero.
              </h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                Você tem 7 dias, a partir da compra, para acessar o curso e decidir se ele é para você. Se por qualquer motivo não for, é só solicitar o reembolso e devolveremos o valor integral para você — sem perguntas, sem burocracia.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* SEÇÃO 29 — FAQ (7 perguntas accordion) */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3">
              Perguntas Frequentes
            </h2>
            <p className="text-gray-600 text-base sm:text-lg">
              Tire todas as suas dúvidas sobre o Amamentação na Prática
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                q: "Por quanto tempo eu tenho acesso ao curso?",
                a: "Você tem 1 ano de acesso completo a toda a plataforma e aos conteúdos do curso."
              },
              {
                q: "Quais formas de pagamento são aceitas?",
                a: "Pix, boleto e cartão de crédito parcelado em até 12x."
              },
              {
                q: "Onde eu tiro dúvidas durante o curso?",
                a: "Você tem suporte especializado dentro da área de membros. Além disso, na página de pagamento você pode garantir acesso à Comunidade Amamentação na Prática no WhatsApp, com contato direto com a Rosane (essa oportunidade só existe naquele momento)."
              },
              {
                q: "Posso assistir as aulas quantas vezes eu quiser?",
                a: "Sim, não há limite de visualizações."
              },
              {
                q: "O acesso é individual?",
                a: "Sim, o acesso é individual e intransferível, vinculado ao seu cadastro na plataforma."
              },
              {
                q: "O curso é só para gestantes ou também serve para quem já é mãe?",
                a: "O curso serve para os dois momentos: se você está grávida, vai chegar ao parto sabendo o que observar; se já é mãe e está com alguma dificuldade agora, vai aprender a identificar e resolver com as técnicas certas."
              }
            ].map((faq, idx) => (
              <div 
                key={idx} 
                className="border border-gray-200 rounded-2xl overflow-hidden transition-all duration-200 bg-white shadow-sm"
              >
                <button
                  onClick={() => toggleFaq(idx)}
                  className="w-full p-5 text-left font-bold text-gray-900 text-base sm:text-lg flex justify-between items-center gap-4 hover:bg-purple-50/50"
                >
                  <span>{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-[#5f448f] transition-transform duration-300 flex-shrink-0 ${openFaq === idx ? 'transform rotate-180' : ''}`} />
                </button>
                {openFaq === idx && (
                  <div className="px-5 pb-5 text-gray-700 text-sm sm:text-base leading-relaxed border-t border-gray-100 pt-4 bg-gray-50/50">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* SEÇÃO 30 — Fechamento final + CTA */}
      <section className="py-16 md:py-24 bg-gradient-to-r from-[#5f448f] via-[#4a3371] to-[#5f448f] text-white text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-8">
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
            Chegou a hora de trocar o improviso pela preparação, e a dor pela técnica certa.
          </h2>

          <div className="pt-4">
            <button
              onClick={scrollToOffer}
              className="w-full sm:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold text-lg sm:text-xl py-4 px-10 rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl flex items-center justify-center gap-3 mx-auto"
            >
              <span>Quero uma amamentação exclusiva e sem dor</span>
              <ArrowRight className="w-6 h-6" />
            </button>
          </div>

        </div>
      </section>

      {/* SEÇÃO 31 — Rodapé */}
      <footer className="bg-[#111827] text-gray-400 py-12 px-4 sm:px-6 border-t border-gray-800 text-sm">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
          
          <div className="space-y-2">
            <p className="font-semibold text-gray-200">
              Amamentação na Prática — Método PPS © 2026. Todos os direitos reservados.
            </p>
            
            {/* RAZÃO SOCIAL E CNPJ — PENDENTE */}
            {/* <!-- RAZÃO SOCIAL E CNPJ — PENDENTE --> */}
            <div className="inline-block px-3 py-1 rounded bg-gray-800/80 border border-gray-700 text-xs text-gray-400">
              [RAZÃO SOCIAL E CNPJ — PENDENTE]
            </div>
          </div>

          <div>
            <a 
              href={PRIVACY_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors underline font-medium"
            >
              Política de Privacidade
            </a>
          </div>

        </div>
      </footer>

    </div>
  );
};

export default AmamentacaoPraticaLP;
